/*
 * Routes for the billing area (Area B: billing and AI credits). Paths are relative; see src/app/routes.ts.
 * /checkout/:sessionId hosts every payment (Dodo's inline checkout inside the portal) in the focus layout.
 */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [
    { path: 'billing/invoices/:id', lazy: page(() => import('./pages/InvoicePage')) },
    { path: 'billing/*', lazy: page(() => import('./pages/BillingPage')) },
  ],
  focus: [{ path: 'checkout/:sessionId', lazy: page(() => import('./pages/CheckoutPage')) }],
}
